type NavigationLink = {
  title: string;
  subtitle?: string;
  icon?: {
    svgUrl: string;
    alt: string;
  };
  href: string;
};

// Product pages
export const PRODUCT_LINK = {
  title: 'Product',
  href: '/product',
} as const satisfies NavigationLink;

export const PRODUCT_TOUR_LINK = {
  title: 'Product Tour',
  href: '/product-tour',
} as const satisfies NavigationLink;

export const WHATS_NEW_LINK = {
  title: "What's New",
  href: '/whats-new',
} as const satisfies NavigationLink;

export const CUSTOMER_SERVICE_LINK = {
  title: 'Customer Service',
  subtitle: 'All-in-one support platform',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-teams-cutomer-service.svg',
    alt: 'Customer Service Icon',
  },
  href: '/customer-service',
} as const satisfies NavigationLink;

export const EMAIL_MANAGEMENT_LINK = {
  title: 'Email Management',
  subtitle: 'Collaborative shared inboxes',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-usecase-email-management.svg',
    alt: 'Email Management Icon',
  },
  href: '/email-management',
} as const satisfies NavigationLink;

export const CLIENT_COMMUNICATION_LINK = {
  title: 'Client Communication',
  subtitle: 'Personalized service at scale',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-usecase-client-communication.svg',
    alt: 'Client Communication Icon',
  },
  href: '/client-communication',
} as const satisfies NavigationLink;

export const AI_LINK = {
  title: 'AI',
  subtitle: 'AI for the hard stuff',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-feature-ai-front-intelligence.svg',
    alt: 'Feature Icon AI',
  },
  href: '/product/ai',
} as const satisfies NavigationLink;

export const OMNICHANNEL_LINK = {
  title: 'Omnichannel',
  subtitle: 'All the channels, zero chaos',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-feature-omnichannel.svg',
    alt: 'Feature Icon Omnichannel',
  },
  href: '/product/omnichannel-support-inbox',
} as const satisfies NavigationLink;

export const FRONT_AI_OVERVIEW_LINK = {
  title: 'Front AI Overview',
  subtitle: 'AI for the hard stuff',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-feature-ai-front-intelligence.svg',
    alt: 'Feature Icon AI',
  },
  href: '/product/ai',
} as const satisfies NavigationLink;

export const AUTOPILOT_LINK = {
  title: 'Autopilot',
  subtitle: 'Beyond happy-path automation',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/autopilot.svg',
    alt: 'Feature Icon Autopilot',
  },
  href: '/product/autopilot-customer-service-automation',
} as const satisfies NavigationLink;

export const TICKETING_LINK = {
  title: 'Ticketing',
  subtitle: 'Complexity in, clarity out',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-feature-ticketing.svg',
    alt: 'Feature Icon Ticketing',
  },
  href: '/product/ticketing-system',
} as const satisfies NavigationLink;

export const COPILOT_LINK = {
  title: 'Copilot',
  subtitle: 'AI help that actually gets complexity',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/copilot.svg',
    alt: 'Feature Icon Copilot',
  },
  href: '/product/copilot-ai-assistant',
} as const satisfies NavigationLink;

export const RESOLVE_LINK = {
  title: 'Resolve',
  subtitle: '24/7 self-serve support',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-feature-livechat.svg',
    alt: 'Feature Icon Resolve',
  },
  href: '/product/resolve-self-serve-ai-support',
} as const satisfies NavigationLink;

export const SMART_QA_LINK = {
  title: 'Smart QA',
  subtitle: 'QA minus the blind spots',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/smartqa.svg',
    alt: 'Feature Icon Smart QA',
  },
  href: '/product/smart-qa-automated-quality-assurance',
} as const satisfies NavigationLink;

export const KNOWLEDGE_BASE_LINK = {
  title: 'Knowledge base',
  subtitle: 'Stop answering déjà vu',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-feature-knowledgebase.svg',
    alt: 'Feature Icon Knowledge Base',
  },
  href: '/product/knowledge-base',
} as const satisfies NavigationLink;

export const SMART_CSAT_LINK = {
  title: 'Smart CSAT',
  subtitle: 'CSAT without the lies',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/smartcsat.svg',
    alt: 'Feature Icon Smart CSAT',
  },
  href: '/product/smart-csat-ai-scoring',
} as const satisfies NavigationLink;

export const COMPASS_LINK = {
  title: 'Compass',
  href: '/product/compass-AI-agent-performance-monitoring',
} as const satisfies NavigationLink;

export const EXTERNAL_AGENT_LINK = {
  title: 'External Agents',
  href: '/product/external-agents-bring-your-own-agent',
} as const satisfies NavigationLink;

export const INTEGRATIONS_API_LINK = {
  title: 'Integrations & API',
  subtitle: 'Escape from tab hell',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-feature-integrations-api.svg',
    alt: 'Feature Icon Integrations',
  },
  href: '/product/integrations-api',
} as const satisfies NavigationLink;

// Industries (Solutions)
export const TECHNOLOGY_LINK = {
  title: 'Tech',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-industry-technology.svg',
    alt: 'Industry Icon Technology',
  },
  href: '/industries/b2b-tech',
} as const satisfies NavigationLink;

export const FINANCIAL_SERVICES_LINK = {
  title: 'Financial Services',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-industry-financial.svg',
    alt: 'Industry Icon Financial Services',
  },
  href: '/industries/financial-services',
} as const satisfies NavigationLink;

export const LOGISTICS_LINK = {
  title: 'Logistics',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-industry-logistics.svg',
    alt: 'Industry Icon Logistics',
  },
  href: '/industries/logistics',
} as const satisfies NavigationLink;

export const MANUFACTURING_LINK = {
  title: 'Manufacturing',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-industry-manufacturing.svg',
    alt: 'Industry Icon Manufacturing',
  },
  href: '/industries/manufacturing',
} as const satisfies NavigationLink;

export const PROFESSIONAL_SERVICES_LINK = {
  title: 'Professional Services',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-industry-professional-services.svg',
    alt: 'Industry Icon Professional Services',
  },
  href: '/industries/professional-services',
} as const satisfies NavigationLink;

export const TRAVEL_LINK = {
  title: 'Travel',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-industry-travel.svg',
    alt: 'Industry Icon Travel',
  },
  href: '/industries/travel',
} as const satisfies NavigationLink;

// Teams (Solutions)
export const CUSTOMER_SUPPORT_LINK = {
  title: 'Customer Support',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-teams-cutomer-service.svg',
    alt: 'Teams Icon Customer Support',
  },
  href: '/teams/customer-service-support',
} as const satisfies NavigationLink;

export const OPERATIONS_LINK = {
  title: 'Operations',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-teams-operations.svg',
    alt: 'Teams Icon Operations',
  },
  href: '/teams/operations',
} as const satisfies NavigationLink;

export const INBOUND_SALES_LINK = {
  title: 'Inbound Sales',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-industry-financial.svg',
    alt: 'Teams Icon Inbound Sales',
  },
  href: '/teams/inbound-sales',
} as const satisfies NavigationLink;

export const ACCOUNT_MANAGEMENT_LINK = {
  title: 'Account Management',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-industry-professional-services.svg',
    alt: 'Teams Icon Account Management',
  },
  href: '/teams/account-management',
} as const satisfies NavigationLink;

export const SUCCESS_LINK = {
  title: 'Customer Success',
  icon: {
    svgUrl: 'https://front.com/webassets/rebrand/icon-teams-success.svg',
    alt: 'Teams Icon Customer Success',
  },
  href: '/teams/customer-success',
} as const satisfies NavigationLink;

// Resources - Using Front
export const ACADEMY_LINK = {
  title: 'Academy',
  href: 'https://academy.front.com/app',
} as const satisfies NavigationLink;

export const COMMUNITY_LINK = {
  title: 'Community',
  href: 'https://community.front.com/',
} as const satisfies NavigationLink;

export const HELP_CENTER_LINK = {
  title: 'Help Center',
  href: 'https://help.front.com/',
} as const satisfies NavigationLink;

export const DEVELOPER_PORTAL_LINK = {
  title: 'Developer Portal',
  href: 'https://dev.frontapp.com/docs/welcome',
} as const satisfies NavigationLink;

// Resources - Explore
export const BLOG_LINK = {
  title: 'Blog',
  href: '/blog',
} as const satisfies NavigationLink;

export const INTEGRATIONS_LINK = {
  title: 'Integrations',
  href: '/integrations',
} as const satisfies NavigationLink;

export const GUIDES_WEBINARS_LINK = {
  title: 'Guides & Webinars',
  href: '/resources',
} as const satisfies NavigationLink;

export const SECURITY_LINK = {
  title: 'Security',
  href: '/security',
} as const satisfies NavigationLink;

export const CUSTOMER_STORIES_LINK = {
  title: 'Customer Stories',
  href: '/customer-stories',
} as const satisfies NavigationLink;

export const DOWNLOAD_APP_LINK = {
  title: 'Download App',
  href: '/download',
} as const satisfies NavigationLink;

export const SUPPORT_REPORT_LINK = {
  title: "Front's Support Report",
  href: '/support-report',
} as const satisfies NavigationLink;

export const CHANNEL_PARTNERSHIPS_LINK = {
  title: 'Channel Partnerships',
  href: '/partners/channel',
} as const satisfies NavigationLink;

export const FRONT_OVERVIEW_LINK = {
  title: 'Front Overview',
  href: '/product',
} as const satisfies NavigationLink;

export const HELP_DESK_LINK = {
  title: 'Help Desk',
  href: '/teams/customer-service-support',
} as const satisfies NavigationLink;

export const SHARED_INBOX_LINK = {
  title: 'Shared Inbox',
  href: '/product/omnichannel-support-inbox',
} as const satisfies NavigationLink;

export const AI_AUTOMATION_LINK = {
  title: 'AI & Automation',
  href: '/product/ai',
} as const satisfies NavigationLink;

export const PRICING_LINK = {
  title: 'Pricing',
  href: '/pricing',
} as const satisfies NavigationLink;

export const PRODUCT_UPDATES_LINK = {
  title: 'Product Updates',
  href: 'https://community.front.com/product-updates',
} as const satisfies NavigationLink;
